export default "__VITE_ASSET__75aa7e21__"